// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b83d56af70f0cabb82282d1a53aaabb2608a21c7.chunk.js";
};